export class SummaryDetail {
    branchNumber?: number;
    jobNumberLabel?: string;
    jobRenewalNumber?: string;
    paymentFees?: number;
    paymentMethod?: {
        code: string, 
        description: string
    };
    totalPremium?: number;
    totalCost?: number;
    changeInCost?: number;

    constructor(data?: SummaryDetail) {
        if (data) {
            Object.assign(this, data);
        }
    }
}